module.exports = __webpack_public_path__ + "img/chevron-left-white.e59f4472.svg";